import { APP_BASE_HREF } from '@angular/common';
import { inject, Injector, NgModule } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { PaymentFailed } from '@home/shared/dialogs/payment-failed/payment-failed.dialog';
import { TrialExpired } from '@home/shared/dialogs/trial-expired/trial-expired.dialog';
import { provideStore } from '@ngxs/store';
import { SharedModule } from '@shared/shared.module';
import { ZefIcons } from 'projects/docs/src/app/+icons/icons.component';
import { IndexPage } from 'projects/docs/src/app/+index/index.component';
import { DocsApp } from 'projects/docs/src/app/docs.component';
import { DocsRouting } from 'projects/docs/src/app/docs.routing';
import { provideHttpClient } from '@angular/common/http';

@NgModule({
  bootstrap: [DocsApp],
  declarations: [DocsApp, ZefIcons, IndexPage, PaymentFailed, TrialExpired],
  exports: [],
  imports: [BrowserModule, BrowserAnimationsModule, DocsRouting, SharedModule],
  providers: [
    provideStore([]),
    provideHttpClient(),
    {
      provide: APP_BASE_HREF,
      useValue: '/',
    },
  ],
})
export class DocsModule {
  readonly injector = inject(Injector);
  readonly registry = inject(MatIconRegistry);

  constructor() {
    const registry = this.registry;

    registry.registerFontClassAlias('zefplayer', 'zef-icons-free');
    registry.registerFontClassAlias('zeficons', 'zef-icons-full');
    registry.setDefaultFontSetClass('zef-icons-full');
  }
}
